import {JobLivePopupService} from '@/services/components/job-live-popup.js';
import { REDIRECT } from '@/imports-files/common/common';

export class JobLivePopupAction
{
    constructor(setApiError, router)
    {
        this.setApiError = setApiError;
        this.router = router;
        this.jobLivePopupService = new JobLivePopupService();
    }

    updateJobLivePopupStatus()
    {
        let params = {id: parseInt(this.router.query.job_id)};
        this.jobLivePopupService.updateLiveJobPopupStatus(params);
        params.setApiError(result.response);
    }

    copyToClipboard(link, setClipBoardMessage)
    {
       var textField        =  document.createElement('textarea');
       textField.innerText  =  link;
       document.body.appendChild(textField);
       textField.select();
       document.execCommand('copy');
       textField.remove();
       setClipBoardMessage('Copied');
       // document.querySelector('.ClipboardTooltip')?.lastChild?.textContent = 'Copied';
    }

    jobViewUrl( client_slug, job_slug)
    {
        let job_url        =  REDIRECT.client.jobs.view_job;
        let protocol       =  window.location.protocol;
        let hostnamearray  =  window.location.host.split('.');
        hostnamearray[0]   =  'jobs';
        job_url            =  job_url.replace('$slug', job_slug);
        job_url            =  job_url.replace('$client_slug', client_slug);
        let url            =  protocol + '//' + hostnamearray.join('.') + job_url+'?q=desc';
        return url;
    }
}
